import Vue from "vue";

export default Vue.extend({
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    disabledTooltip: {
      type: String,
      required: false,
      default: null,
    },
  },
  computed: {
    tooltipIfDisabled(): string {
      return this.disabled ? this.disabledTooltip : null
    },
  },
});